const PostSummary = {
    selector: '.summary-list',
    eltSelector: '.summary-elt',
    associations: [],
    scrollOffset: 100,
    eltActiveClass: 'summary-active',
    eltBeforeActiveClass: 'summary-before-active',
};

let instance = null;

// Header sticky : l'offset de scroll est calculé dynamiquement sur sa hauteur
// réelle (elle varie selon le breakpoint), avec une marge de respiration.
const HEADER_SELECTOR = '[js-header]';
const OFFSET_MARGIN = 24;

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const getScrollOffset = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
    return headerHeight ? headerHeight + OFFSET_MARGIN : PostSummary.scrollOffset;
};

const getPostSummary = () => {
    if (instance === null) {
        instance = document.querySelector(PostSummary.selector);

        if (instance && instance.hasAttribute('scroll-offset')) {
            const scrollOffset = Number(instance.getAttribute('scroll-offset'));
            if (!Number.isNaN(scrollOffset)) {
                PostSummary.scrollOffset = scrollOffset;
            }
        }

        if (instance && instance.getAttribute('active-class')) {
            PostSummary.eltActiveClass = instance.getAttribute('active-class');
        }

        if (instance && instance.getAttribute('before-active-class')) {
            PostSummary.eltBeforeActiveClass = instance.getAttribute('before-active-class');
        }
    }

    return instance;
};

// Cible d'une entrée : le titre de l'article, retrouvé par son id (href="#id").
const targetOf = (link) => {
    const href = link.getAttribute('href') || '';
    const id = href.startsWith('#') ? decodeURIComponent(href.slice(1)) : '';
    return id ? document.getElementById(id) : null;
};

// Relie chaque entrée à son titre (par id) et installe le scroll doux au clic.
// Les entrées sont de vraies ancres : sans JS, le saut natif fonctionne déjà.
const initElt = (list) => {
    const links = Array.from(list.querySelectorAll(PostSummary.eltSelector));

    links.forEach((link) => {
        const target = targetOf(link);

        if (!target) {
            return;
        }

        PostSummary.associations.push({ content: target, summary: link });

        link.addEventListener('click', (event) => {
            event.preventDefault();

            window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - getScrollOffset(),
                behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            });

            if (window.history && window.history.replaceState) {
                window.history.replaceState(null, '', link.getAttribute('href'));
            }
        });
    });
};

const setBeforeActive = (elt) => {
    elt.classList.remove(PostSummary.eltActiveClass);
    elt.classList.add(PostSummary.eltBeforeActiveClass);
};

const setActive = (elt) => {
    elt.classList.remove(PostSummary.eltBeforeActiveClass);
    elt.classList.add(PostSummary.eltActiveClass);
};

const setInactive = (elt) => {
    elt.classList.remove(PostSummary.eltActiveClass);
    elt.classList.remove(PostSummary.eltBeforeActiveClass);
};

// Surlignage de la section courante au scroll (conservé : sert dès que le
// sommaire reste visible pendant la lecture, ex. version sticky à venir).
const handleScroll = () => {
    const threshold = window.innerHeight / 2;
    let activeIndex = -1;

    PostSummary.associations.forEach((association, idx) => {
        if (association.content.getBoundingClientRect().top <= threshold) {
            activeIndex = idx;
        }
    });

    PostSummary.associations.forEach((association, idx) => {
        if (idx < activeIndex) {
            setBeforeActive(association.summary);
        } else if (idx === activeIndex) {
            setActive(association.summary);
        } else {
            setInactive(association.summary);
        }
    });

    if (activeIndex === -1 && PostSummary.associations.length > 0) {
        setActive(PostSummary.associations[0].summary);
    }
};

// Repli / dépli du sommaire.
const initToggle = () => {
    const toggle = document.querySelector('[js-toggle-summary]');
    const container = document.querySelector('[js-summary-container]');
    const content = document.querySelector('[js-summary-content]');

    if (!toggle || !container || !content) {
        return;
    }

    // scrollHeight = hauteur naturelle du contenu (non bornée par max-height),
    // recalculée à l'ouverture et au resize pour éviter tout clipping quand la
    // liste se re-répartit selon le breakpoint.
    const syncHeight = () => {
        content.style.maxHeight = container.classList.contains('is-open') ? `${content.scrollHeight}px` : '0px';
    };

    syncHeight();

    toggle.addEventListener('click', () => {
        const isOpen = container.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        syncHeight();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncHeight, 150);
    });
};

const init = () => {
    window.addEventListener('load', () => {
        const list = getPostSummary();

        if (!list) {
            return;
        }

        initElt(list);
        initToggle();

        if (PostSummary.associations.length) {
            window.addEventListener('scroll', handleScroll);
            handleScroll();
        }
    });
};

init();
